import { useAppDispatch, useAppState } from 'Context/AppContext/AppContext'
import { ApolloError, useLazyQuery } from '@apollo/client'
import { useEffect } from 'react'
import { useLogging } from 'Hooks/useLogging'
import GET_CAMPAIGNS from 'Apollo/Queries/GetCampaigns'
import { UPDATE_CAMPAIGNS } from 'TypeDefs/AppContext'

const useCampaigns = () => {
  const {
    nonprofitOrgConfig: { orgId },
    filterDate,
  } = useAppState()

  const dispatch = useAppDispatch()
  const logger = useLogging('useDonations')

  const [getCampaigns, { loading }] = useLazyQuery(GET_CAMPAIGNS, {
    // fetchPolicy: 'cache-and-network',
    context: { clientName: 'batched' },
    variables: { nonprofitOrgId: orgId, createdAfter: filterDate },
    onCompleted: (data) => {
      const campaigns = data?.campaigns || []
      dispatch({
        type: UPDATE_CAMPAIGNS,
        payload: {
          isLoading: loading,
          data: campaigns,
        },
      })
    },
    onError: (err: ApolloError) => {
      dispatch({
        type: UPDATE_CAMPAIGNS,
        payload: {
          isLoading: false,
          data: [],
        },
      })
      logger.error(err)
    },
  })

  useEffect(() => {
    if (orgId) {
      getCampaigns()
    }
  }, [getCampaigns, orgId])
}

export default useCampaigns
